import { DAYS_OF_WEEK } from './types/days-of-week';
import { MONTHS } from './types/months';

export interface FormatDateOptions {
  includeDay?: boolean;
  includeDate?: boolean;
  includeYear?: boolean;
  noCommas?: boolean;
}

export const formatDate = (
  date: Date,
  {
    includeDay = false,
    includeDate = false,
    includeYear = true,
    noCommas = false,
  }: FormatDateOptions = {},
): string => {
  let formattedDate = '';

  if (includeDay) {
    formattedDate += DAYS_OF_WEEK[date.getUTCDay()];
    formattedDate += ', ';
  }

  formattedDate += MONTHS[date.getUTCMonth()];

  if (includeDate) {
    formattedDate += ' ';
    formattedDate += date.getUTCDate();
  }

  if (includeYear) {
    formattedDate += ', ';
    formattedDate += date.getUTCFullYear();
  }

  if (noCommas) formattedDate = formattedDate.replace(',', '');

  return formattedDate;
};

export const formatDateV2 = (
  date: Date,
  {
    includeDay = false,
    includeDate = false,
    includeYear = true,
    noCommas = false,
  }: FormatDateOptions = {},
): string => {
  let formattedDate = '';

  if (includeDay) {
    formattedDate += DAYS_OF_WEEK[date.getDay()];
    formattedDate += ', ';
  }

  formattedDate += MONTHS[date.getMonth()];

  if (includeDate) {
    formattedDate += ' ';
    formattedDate += date.getDate();
  }

  if (includeYear) {
    formattedDate += ', ';
    formattedDate += date.getFullYear();
  }

  if (noCommas) formattedDate = formattedDate.replace(',', '');

  return formattedDate;
};
